<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title">Preview</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ngb-progressbar type="info" [value]="progressValue">{{ progressText }}</ngb-progressbar>

        <pdf-viewer [src]="data" [render-text]="true"></pdf-viewer>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-outline-dark" (click)="c('Close click')">Close</button>
    </div>
</ng-template>
<i class="fa fa-eye" (click)="open(content)"></i>